var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.wrapperTag,{tag:"component",staticClass:"table-form-row"},[_vm._l((_vm.headers),function(header){return _vm._t(`item-${header.value}`)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }